export default __webpack_public_path__ + "static/media/dole-logo.556a5060.png";